// Component Name:  StatusMessage component
// Author: Lavanya S
// Platform:
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date: 22-05-2025
// Description:  This component is designed to Reset the user password
// Dependencies: React library,
// Interfaces: props
// Maintenance History: 1.0 First Version

import React, { Component } from "react";
import { Row, Col, Alert, Button, Container, FormGroup, Label } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import { forgetUserSuccessful, resetPassword, userForgetPasswordError } from "../../store/actions";

// import images
import logodark from "../../assets/images/logo-dark.png";
import LKTimer from "../../assets/images/LK_Icons/LK__Timer-clock.svg";
import LKLockImg from "../../assets/images/auth/LK_Lock.svg";
import eyeOpenIcon from "../../assets/images/auth/LK_Eye Open.svg";
import eyeCloseIcon from "../../assets/images/auth/LK_Eye Close.svg";
import { ActiveBtn } from "../Utility/Button";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remainingTime: 0,
    };
    this.timerInterval = null;

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }
  componentDidMount() {
    if (this.props.OTPTime) {
      this.startTimer();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.OTPTime && this.props.OTPTime !== prevProps.OTPTime) {
      console.log("this.props.OTPTime: ", this.props.OTPTime);
      this.startTimer();
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  }

  startTimer = () => {
    clearInterval(this.timerInterval);

    this.timerInterval = setInterval(() => {
      const secondsPassed = Math.floor((Date.now() - this.props.OTPTime) / 1000);
      const timeLeft = 600 - secondsPassed;

      if (timeLeft <= 0) {
        clearInterval(this.timerInterval);
        // this.props.clearOtp();
        this.setState({ remainingTime: 0 });
        this.props.userForgetPasswordError({ msg: "OTP has Expired" });
        this.props.history.push("/forgot-password")
        // this.props.forgetUserSuccessful
      } else {
        this.setState({ remainingTime: timeLeft });
      }
    }, 1000);
  };

  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  // handleValidSubmit
  handleValidSubmit(event, values) {
    this.props.resetPassword({ email: this.props.user, otp: values.otp, newPassword: values.password }, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div>
          <Container fluid className="p-0">
            <Row className="no-gutters">
              <div className="authentication-bg" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100vh" }}>
                <div className="bg-overlay"></div>
              </div>
              <Col xs={12} className="p-0">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    minHeight: "100vh",
                    width: "100%",
                  }}
                >
                  <div
                    className="p-4"
                    style={{
                      maxWidth: "600px",
                      backgroundColor: "#FFFFFF",
                      boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                  >
                    <Row className="justify-content-center">
                      <Col lg={12}>
                        <div>
                          <div className="text-center">
                            <div>
                              <Link to="/" className="logo">
                                <img src={logodark} height="40" alt="logo" />
                              </Link>
                            </div>

                            <h4 className="font-size-18 mt-1">Create New Password</h4>
                            <p className="text-muted">
                              Your password must be at least 8 characters and should include a combination of numbers, letters and special characters(!$@%)
                            </p>
                            {/* {this.state.timeLeft > 0 && ( */}
                              <span>
                                Expires in: <b>{this.formatTime(this.state.remainingTime)}</b>
                              </span>
                            {/* )} */}
                          </div>
                          {this.props.forgetError?.msg ? (
                            <Alert color="danger" className="mb-4">
                              {this.props.forgetError?.msg}
                            </Alert>
                          ) : null}
                          {this.props.message ? (
                            <Alert color="success" className="mb-4">
                              {this.props.message}
                            </Alert>
                          ) : null}
                          <div className="p-2 mt-1">
                            <AvForm className="form-horizontal" onValidSubmit={this.handleValidSubmit}>
                              <FormGroup className="auth-form-group-custom mb-4">
                                <img src={LKTimer} alt="user icon" style={{ width: "25px", height: "25px" }} className="auti-custom-input-icon" />
                                <Label htmlFor="otp">PassCode</Label>
                                <AvField
                                  name="otp"
                                  value={this.state.username}
                                  type="text"
                                  validate={{
                                    required: { value: true, errorMessage: "This field is required" },
                                    pattern: {
                                      value: /^[0-9]{8}$/,
                                      errorMessage: "Must be exact 8 digits ",
                                    },
                                  }}
                                  className="form-control"
                                  id="otp"
                                  placeholder="Enter One-Time passcode"
                                />
                              </FormGroup>
                              <FormGroup className="auth-form-group-custom mb-4">
                                <img src={LKLockImg} alt="lock icon" style={{ width: "25px", height: "25px" }} className="auti-custom-input-icon" />
                                <Label htmlFor="userpassword">Password</Label>
                                <AvField
                                  name="password"
                                  value={this.state.password}
                                  type={this.state.isPasswordShown ? "text" : "password"}
                                  className="form-control"
                                  validate={{
                                    required: { value: true, errorMessage: "Password is required" },
                                    minLength: { value: 8, errorMessage: "Password must be at least 8 characters long" },
                                    pattern: {
                                      value: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/,
                                      errorMessage: "Password must include a combination of numbers, letters, and special characters (!$@%)",
                                    },
                                  }}
                                  id="userpassword"
                                  placeholder="Enter password"
                                />
                                <img
                                  src={this.state.isPasswordShown ? eyeOpenIcon : eyeCloseIcon}
                                  alt="lock icon"
                                  style={{ cursor: "pointer", position: "absolute", top: "30%", right: "5%", width: "25px", height: "25px" }}
                                  onClick={() => this.setState({ isPasswordShown: !this.state.isPasswordShown })}
                                />
                              </FormGroup>
                              <FormGroup className="auth-form-group-custom mb-4">
                                <img src={LKLockImg} alt="lock icon" style={{ width: "25px", height: "25px" }} className="auti-custom-input-icon" />
                                <Label htmlFor="confirmPassword">Confirm Password</Label>
                                <AvField
                                  name="confirmPassword"
                                  value={this.state.confirmPassword}
                                  type={this.state.isConfirmPasswordShown ? "text" : "password"}
                                  className="form-control"
                                  id="confirmPassword"
                                  validate={{
                                    required: { value: true, errorMessage: "Confirm Password is required" },
                                    match: { value: "password", errorMessage: "Passwords do not match" },
                                  }}
                                  placeholder="Re-enter password"
                                  //   onChange={(e) => this.setState({ password: e.target.value })}
                                />
                                <img
                                  src={this.state.isConfirmPasswordShown ? eyeOpenIcon : eyeCloseIcon}
                                  alt="lock icon"
                                  style={{ cursor: "pointer", position: "absolute", top: "30%", right: "5%", width: "25px", height: "25px" }}
                                  onClick={() => this.setState({ isConfirmPasswordShown: !this.state.isConfirmPasswordShown })}
                                />
                              </FormGroup>

                              <div className="mt-4 d-flex justify-content-center">
                                <ActiveBtn name="Reset" handleClick={() => {}} />
                              </div>
                            </AvForm>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { message, forgetError, loading, OTPTime, user } = state.Forget;
  return { message, forgetError, loading, OTPTime, user };
};

export default withRouter(connect(mapStatetoProps, { resetPassword, userForgetPasswordError })(ResetPassword));
